import { FC, memo, useMemo } from 'react'
import { Box, Flex, Stack, Text } from '@chakra-ui/react'
import Link from 'next/link'

import { Notification } from 'types'
import { Id, VulnerabilityAlertsModuleBrand } from 'components'
import { formatDateToString, formatHourToString } from 'utils/transforms/date'
import { ALERTS_OF_VULNERABILITY_ROUTES } from 'AlertsOfVulnerability/constants/routes'

type Props = {
  notification: Notification
  setNotificationAsReaded: () => Promise<void>
}

const NotificationNewAlert: FC<Props> = ({ notification, setNotificationAsReaded }) => {
  const pathToAlertProfile = useMemo(() => {
    return ALERTS_OF_VULNERABILITY_ROUTES.ALERT_PROFILE.replace('[alertSlug]', notification.alert_slug as string)
  }, [])

  return (
    <Link href={pathToAlertProfile} target="_blank">
      <Flex
        bg="light"
        className="accessible"
        rounded="none"
        position="relative"
        align="center"
        borderBottomWidth="1px"
        borderColor="borderColor"
        gap={4}
        py={2}
        px={4}
        _hover={{ bg: 'lightPrimary' }}
        onClick={setNotificationAsReaded}
      >
        <VulnerabilityAlertsModuleBrand />

        <Stack spacing={1}>
          <Flex align="center" gap={2}>
            <Id id={notification.alert_id} />
            <Text fontSize="md">Novo alerta: {notification.alert_alert_type_name}</Text>
          </Flex>

          <Flex align="center" gap={1}>
            <Text variant="secondary" fontSize="xs">
              Criado em
            </Text>
            <Text variant="secondary" fontSize="xs">
              {formatDateToString(notification.alert_created_at || notification.created_at)} ás{' '}
              {formatHourToString(notification.alert_created_at || notification.created_at)}
            </Text>
          </Flex>
        </Stack>

        {!notification.viewed_at && <Box position="absolute" top={3} right={4} bg="success" height="10px" width="10px" rounded="full" />}
      </Flex>
    </Link>
  )
}

export default memo(NotificationNewAlert)
